// @flow
import type { Epic } from '../../annotations';
import * as r from 'ramda';
import * as mA from 'most-adjunct';
import * as mostc from '../../crosscutting/mostc';
import * as most from 'most';

// We need to setup a background process that
// every few seconds checks if we are finally able to start
// processing the analytics queue. To do this we want to check
// if GA is on the page. Once it is we process each item in the queue
// until it is empty. Once it is empty we will wait until the next poll
// tick.
const analyticsWorkerEpic = (
  window: Object,
  analyticsQueue: Array<Function>,
): Epic => (
) => r.pipe(
  mostc.map(() => {
    // We want to check if the GA library is in the page yet.
    // If it isn't then we can skip this tick.
    if (window.ga == null) {
      return;
    }

    // Process all of the entries in the queue until it is empty.
    // We do it this way instead of an entry per tick so that we can ensure
    // that we do not get a backlog.
    while (analyticsQueue.length > 0) {
      const fn = analyticsQueue.pop();
      fn(window.ga);
    }
  }),
  mA.ignoreElements,
)(most.periodic(5000));

export default analyticsWorkerEpic;
